export default {"src":"/_next/static/media/zhk-orange-logo.72564394.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};